import { AppNS } from 'app';
import { Params } from 'app/types';
import { FileInfo } from 'app/ui/components/multi-file-uploader/MultiFileUploader';

export const parseDocumentResponse = (data: Params): FileInfo => {
  return {
    id: data.id,
    documentId: data.id,
    thumbnail: '',
    url: data.fileUrl.url,
    uppyId: data.id,
    name: data.file.fileName,
    isLoaded: true,
    isRemoved: false,
    type: data.type,
    metadata: data.metadata,
    state: 'uploaded',
  };
};

export const parseDocumentCollectionResponse = (data: Params[]): FileInfo[] => {
  return data.map((item) => parseDocumentResponse(item));
};

export const parseCompanyDocumentsData = (data: AppNS.Params[]): FileInfo[] => {
  if (!data) {
    return [];
  }
  return data.map((item: AppNS.Params) => {
    return {
      id: item.id,
      type: item.type,
      expirationDate: item.expirationDate,
      certificateNumber: item.certificateNumber,
      documentId: item.id,
      thumbnail: '',
      url: item.fileUrl.url,
      uppyId: '',
      name: item.file.fileName,
      isLoaded: true,
      isRemoved: false,
      state: 'uploaded',
      uploadProgress: 100,
    };
  });
};

export const parseInspectorDisciplineDocumentsData = (data: AppNS.Params[]): AppNS.InspectorDisciplineDocument[] => {
  if (!data) {
    return [];
  }

  return data.map((item: AppNS.Params) => {
    const url = item?.fileUrl?.url || item.url;

    return {
      documents: url
        ? [
            {
              id: item.id,
              documentId: item.id,
              thumbnail: '',
              url: item?.fileUrl?.url || item.url,
              uppyId: '',
              name: item?.file?.fileName || '',
              isLoaded: true,
              isRemoved: false,
              state: 'uploaded',
              uploadProgress: 100,
            },
          ]
        : [],
      metadata: item.metadata,
      id: item.id,
      type: item.type || '',
      expirationDate: item.expirationDate,
      certificateNumber: item.certificateNumber || '',
      documentId: item.id,
      archivedAt: item.archivedAt,
    } as AppNS.InspectorDisciplineDocument;
  });
};
